require("../sass/style.scss");
require("../fonts/fontello/css/fontello.css");
require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/fslightbox");
require("./vendor/select");
require("./vendor/pdf-uploader");

(function ($) {
  $(".header").length > 0 && require("./template_parts/header.es6");
})(jQuery);
(function ($) {
  $(".hero-home").length > 0 && require("./template_parts/hero_home.es6");
})(jQuery);
(function ($) {
  $(".validated").length > 0 && require("./template_parts/validated.es6");
})(jQuery);
(function ($) {
  $(".studies-say").length > 0 && require("./template_parts/studies_say.es6");
})(jQuery);
(function ($) {
  $(".faq").length > 0 && require("./template_parts/faq.es6");
})(jQuery);
(function ($) {
  $(".professionals").length > 0 && require("./template_parts/professionals.es6");
})(jQuery);
(function ($) {
  $(".data").length > 0 && require("./template_parts/performance_data.es6");
})(jQuery);
(function ($) {
  $(".equipment").length > 0 && require("./template_parts/equipment.es6");
})(jQuery);
(function ($) {
  $(".steps").length > 0 && require("./template_parts/steps.es6");
})(jQuery);
(function ($) {
  $(".learn-more").length > 0 && require("./template_parts/learn_more.es6");
})(jQuery);
(function ($) {
  $(".image").length > 0 && require("./template_parts/image.es6");
})(jQuery);
(function ($) {
  $(".responsibility").length > 0 && require("./template_parts/responsibility.es6");
})(jQuery);
(function ($) {
  $(".single-post").length > 0 && require("./template_parts/single-post.es6");
})(jQuery);
(function ($) {
  $(".about-product").length > 0 && require("./template_parts/about_product.es6");
})(jQuery);
(function ($) {
  $(".about-us").length > 0 && require("./template_parts/about_us.es6");
})(jQuery);
(function ($) {
  $(".list-template").length > 0 && require("./template_parts/list-template.es6");
  $(".webinar-modal").length > 0 && require("./template_parts/webinar-modal.es6");
  $(".contacts__main").length > 0 && require("./template_parts/contact.es6");
})(jQuery);


